<template>
  <div class="churn-rate-container">
    <div class="tab-header-container">
      <div class="tab-container">
        <div class="tab-button-container" v-for="(item, index) in listTab" v-bind:key="index">
          <div
            v-if="item.isActive"
            :class="keyTabActive == item.key ? 'button-tab-container-active' : 'button-tab-container'"
            @click="onClickTab(item.key)"
          >
            <div class="text-button">
              <div class="tab-item-icon"><component :is="item.icon" v-if="item.icon" /></div>
              <div class="tab-item-text">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cal-button-container">
        <button class="btn btn-outline-primary d-flex align-items-center cal-button" @click="onClickCalButton">
          <div class="cal-icon">
            <calculate-icon class="icon-cal" />
          </div>
          <div class="button-text">{{ 'คำนวณอัตราการเลิกเป็นลูกค้า' }}</div>
        </button>
      </div>
    </div>
    <div class="sub-tab-header-container">
      <div class="border-bottom-container">
        <div class="left-container">
          <div class="sub-tab-container" v-if="keyTabActive == 1">
            <div class="sub-tab-button-container" v-for="(item, index) in listSubTab" v-bind:key="index">
              <div
                v-if="item.isActive"
                :class="keySubTabActive == item.key ? 'button-sub-tab-container-active' : 'button-sub-tab-container'"
                @click="onClickSubTab(item.key)"
              >
                <div class="text-sub-button">
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sub-tab-container" v-else></div>
        </div>
        <div class="right-container"></div>
      </div>
    </div>
    <div v-if="keySubTabActive == 1" class="body-content-container"><SegmentList /></div>
    <div v-else-if="keySubTabActive == 2" class="body-content-container"><OverViewAnal /></div>
    <!-- <div v-else-if="keySubTabActive == 3" class="body-content-container"><AllFolderTab /></div>
    <div v-else-if="keySubTabActive == 4" class="body-content-container"><AllSegmentTab /></div> -->
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';
import router from '@/router';
import DashboardDefaultTabIcon from '@/assets/icons/modules/customer-insight/DashboardDefaultTabIcon.vue';
import CalculateIcon from '@/assets/icons/modules/analytics/churn-rate/CalculateIcon.vue';
import SegmentList from '../../components/anal-churnrate/SegmentList.vue';
import OverViewAnal from '../../components/anal-churnrate/OverViewAnal.vue';

// import AllFolderTab from './components/AllFolderTab.vue';
// import AllSegmentTab from './components/AllSegmentTab.vue';

import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const keyTabActive: Ref<number> = ref(1);
const keySubTabActive: Ref<number> = ref(1);
const listTab = [
  { key: 1, title: 'อัตราการเลิกเป็นลูกค้า', isActive: true, icon: markRaw(DashboardDefaultTabIcon) },
  { key: 2, title: 'Dashboard', isActive: false, icon: markRaw(DashboardDefaultTabIcon) },
];
const listSubTab = [
  { key: 1, title: 'เฉพาะกลุ่มเป้าหมาย', isActive: true },
  { key: 2, title: 'ภาพรวม', isActive: true },
  { key: 3, title: 'โฟลเดอร์ทั้งหมด', isActive: false },
  { key: 4, title: 'กลุ่มเป้าหมายทั้งหมด', isActive: false },
];

function onClickTab(tabActive: number) {
  keyTabActive.value = tabActive;
}

function onClickCalButton() {
  router.push({
    path: '/analytics/churnRate/calculate',
    query: {
      ...router.currentRoute.value.query,
    },
  });
}

function onClickSubTab(tabActive: number) {
  router.push({ query: { subtab: tabActive } });
  keySubTabActive.value = tabActive;
}

onBeforeMount(() => {
  if (router.currentRoute.value.query.subtab) {
    keySubTabActive.value = Number(router.currentRoute.value.query.subtab);
  }
});
</script>

<style lang="scss" scoped>
.churn-rate-container {
  .tab-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .cal-button-container {
      display: flex;
      justify-content: flex-end;
      position: relative;
      right: 0;
      z-index: 1;
      margin-left: 0.5rem;
      width: auto;
      .cal-button {
        font-size: 15px;
        padding: 0.625rem;
        line-height: 1;
        border-radius: 7px;
        background: #FFF;

        .cal-icon {
          margin-right: 0.5rem;
          svg {
            width: 21px;
            height: 21px;
            fill: #0d6efd;
          }
        }
        &:hover {
          box-shadow: #0038b7 -4px 4px 10px -6px;
          background: #0d6efd;

          .cal-icon {
            svg {
              fill: #fff;
            }
          }
        }
      }
    }
    .tab-container {
      display: flex;
      .tab-button-container {
        .button-tab-container-active {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #fff;
          border-radius: 0.5rem 0.5rem 0 0;
          box-shadow: 0 2px 4px #eaf0f5;
          min-width: 220px;
          width: auto;
          height: 70px;
          pointer-events: all;
          z-index: 3;
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            z-index: 1;
            top: 0;
            right: -0.75rem;
            bottom: 0;
            width: 2rem;
            background: #fff;
            box-shadow: 4px 2px 4px #eaf0f5;
            transform: skew(18deg);
            border-radius: 0 10px 0 0;
            border-right: 1px solid #eaf0f5;
          }
          .tab-item-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0.5rem;
            width: 24px;
            height: 24px;
            overflow: hidden;
            filter: none;
            svg {
              width: 18px;
              object-fit: contain;
              object-position: center;
              -o-object-fit: contain;
              -o-object-position: center;
            }
          }
        }
        .text-button {
          display: flex;
          .tab-item-text {
            color: #000;
          }
        }
      }
      .button-tab-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fafbfe;
        border-radius: 0.5rem 0.5rem 0 0;
        min-width: 220px;
        width: auto;
        height: 70px;
        pointer-events: all;
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          z-index: 1;
          top: 0;
          right: -0.75rem;
          bottom: 0;
          width: 2rem;
          background: #fafbfe;
          transform: skew(18deg);
          border-radius: 0 10px 0 0;
          border-right: 1px solid #eaf0f5;
        }
        .tab-item-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 0.5rem;
          width: 24px;
          height: 24px;
          overflow: hidden;
          filter: grayscale(1);
          svg {
            width: 18px;
            object-fit: contain;
            object-position: center;
            -o-object-fit: contain;
            -o-object-position: center;
          }
        }
        .text-button {
          display: flex;
          .tab-item-text {
            color: #606a6c;
          }
        }
      }
    }
  }
  .sub-tab-header-container {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-color: #fff;
    border-top-right-radius: 0.5rem;
    width: 100%;
    min-height: 70px;
    .border-bottom-container {
      display: flex;
      width: 98%;
      justify-content: space-between;
      align-items: flex-end;
      padding-left: 1rem;
      padding-right: 1rem;
      border-bottom: 3px solid #f5f7fb;

      .left-container {
        display: flex;
        .sub-tab-container {
          display: flex;
          .sub-tab-button-container {
            .button-sub-tab-container-active {
              display: flex;
              justify-content: center;
              align-items: center;
              border-bottom: 3px solid #000;
              border-top-left-radius: 0.5rem;
              border-top-right-radius: 0.5rem;
              min-height: 50px;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
              pointer-events: all;
              z-index: 3;
              cursor: pointer;
            }
            .button-sub-tab-container {
              display: flex;
              justify-content: center;
              align-items: center;
              border-bottom: 3px solid #fff;
              border-top-left-radius: 0.5rem;
              border-top-right-radius: 0.5rem;
              min-height: 50px;
              margin-left: 0.5rem;
              margin-right: 0.5rem;
              pointer-events: all;
              z-index: 3;
              cursor: pointer;
            }
          }
        }
      }
      .right-container {
        display: flex;
      }
    }
  }
  .body-content-container {
    display: flex;
    width: 100%;
  }
}
</style>
